import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../redux/features/app/appSlice";

export default configureStore({
  reducer: {
    app: appReducer,
  },
});
